import React, { SyntheticEvent } from 'react';
//import { BlurhashCanvas } from 'react-blurhash';
import * as Styles from './MBImage.styles';
import type { ratioTypes } from './MBImage.types';

interface ImageProps {
  imageUrl?: string;
  blurHash?: string;
  url?: string;
  onClick?: (e: SyntheticEvent) => void;
  borderRadius?: number;
  aspectRatio?: ratioTypes | number;
  imageDecodeMode?: React.ImgHTMLAttributes<HTMLImageElement>['loading'];
  alt?: string;
  bgColor?: string;
  isImageContained?: boolean;
}

const Image: React.FC<ImageProps> = ({
  imageUrl,
  //blurHash,
  onClick: handleCoverImageClick,
  aspectRatio,
  imageDecodeMode,
  borderRadius = 20,
  alt: title = '',
  url = '',
  bgColor = 'none',
  isImageContained = false,
}) => {
  return (
    <Styles.CoverImage
      as={url?.length > 0 ? 'a' : 'div'}
      href={url}
      onClick={handleCoverImageClick}
      aspectRatio={aspectRatio}
      borderRadius={borderRadius}
      bgColor={bgColor}
      isImageContained={isImageContained}
    >
      {/* blurHash != null && <BlurhashCanvas hash={blurHash} /> */}
      {imageUrl != null && (
        <img
          alt={title}
          src={imageUrl}
          loading={imageDecodeMode}
          data-pin-nopin
        />
      )}
    </Styles.CoverImage>
  );
};

export default Image;
